import { Divider } from 'antd'
import HelpIcon from '../HelpIcon'
import { CIMSDividerProps } from './types'

const CIMSDivider: React.FC<CIMSDividerProps> = ({ help, children }) => {
  return (
    <Divider orientation="left">
      {children && <HelpIcon text={help}>{children}</HelpIcon>}
    </Divider>
  )
}

export default CIMSDivider
